<template>
  <table v-table-resizer class="table table-striped">
    <thead>
      <tr>
        <th class="fandom">Fandom</th>
        <th class="characters" v-if="!options.hideCharacters">Characters</th>
        <th class="prompts">Requests</th>
      </tr>
    </thead>
    <tbody v-if="!updating && !processing && filtered.length">
      <tr v-for="fandom in filtered" :key="fandom.index">
        <td class="fandom" data-label="Fandom">
          <router-link class="text-bold" :to="`/${exchangeId}/fandom/${encodeURIComponent(fandom.name)}`">{{ fandom.name
            }}</router-link>
          <router-link v-if="isAggregable(fandom.name)" class=""
            :to="`/${exchangeId}/aggregate?groupby=${encodeURIComponent(fandom.name)}`"
            title="See all previously requested prompts for users who nominated this tag">&nbsp;<i
              class="fas fa-external-link-alt"></i></router-link>&nbsp;
          <!-- Only allow bookmarks for closed collections for sanity's sake -->
          <button aria-label="Toggle fandom bookmark" class="bookmark" @click="toggle(fandom)">
            <span v-if="hasBookmark(fandom)" class="fas fa-heart" aria-label="Remove bookmark"></span>
            <span v-else class="far fa-heart" aria-label="Bookmark"></span>
          </button>
          <div class="meta text-small">
            <span class="label" v-if="fandom.categories">{{
              fandom.categories.join(", ")
            }}</span>
          </div>
        </td>
        <td class="characters" v-if="!options.hideCharacters">
          <ul>
            <li v-for="char in getCharacters(fandom.index, fandom.name)" :key="char">
              {{ char }}
            </li>
          </ul>
        </td>
        <td class="prompts">
          <button class="btn btn-primary"
            v-if="!prompts[fandom.index] && hasPrompts[fandom.index] && hasPrompts[fandom.index].has_prompts"
            @click="getPrompts(exchangeId, fandom.index, fandom.name)">
            Show Requests
          </button>
          <div v-if="prompts[fandom.index] === 'loading'" class="loading">
          </div>

          <keep-alive>
            <prompt-table :key="`pt-${fandom.index}`" :prompts="prompts[fandom.index]" v-if="prompts[fandom.index] &&
              prompts[fandom.index].length &&
              prompts[fandom.index] !== 'loading'
            ">
            </prompt-table>
            <span v-else-if="!hasPrompts[fandom.index] || !hasPrompts[fandom.index].has_prompts">No prompts ):</span>
          </keep-alive>
        </td>
      </tr>
    </tbody>
  </table>
</template>


<script>
import PromptTable from "../components/promptTable.vue";
import utils from "../components/utils.js";
import tableResizer from "../directives/tableResizer";
// third party
import { mapGetters } from "vuex";

export default {
  name: "fandomTable",
  directives: {
    tableResizer
  },
  components: {
    PromptTable
  },
  props: {
    updating: {
      type: Boolean,
      default: true
    },
    processing: {
      type: Boolean,
      default: true
    },
    filtered: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters([
      "exchangeId",
      "isExchangeOpen",
      "bookmarks",
      "categories",
      "characters",
      "fandoms",
      "hasPrompts",
      "letters",
      "loadAll",
      "loaded",
      "options",
      "promptmarks",
      "prompts"
    ])
  },
  methods: {
    ...utils
  }
};
</script>